import { Breadcrumb as AranduBreadcrumb, BreadcrumbLink, BreadcrumbPage } from '@ads/components-react';
import { Home } from '@ads/icons';
import type { ReactNode } from 'react';

export interface BreadcrumbItem {
  id: string;
  label: ReactNode;
  href?: string;
  isCurrent?: boolean;
}

export interface BreadcrumbProps {
  crumbs: BreadcrumbItem[];
  homeHref?: string;
  homeAriaLabel?: string;
  ariaLabel?: string;
}

const Breadcrumb = ({ crumbs, homeHref, homeAriaLabel, ariaLabel }: BreadcrumbProps) => (
  <AranduBreadcrumb aria-label={ariaLabel} custom={{ list: 'pb-micro overflow-x-auto' }}>
    {homeHref && (
      <BreadcrumbLink href={homeHref} aria-label={homeAriaLabel}>
        <Home className='size-[1em] text-ctx-content-base' aria-hidden />
      </BreadcrumbLink>
    )}

    {crumbs.map((crumb) =>
      crumb.isCurrent || !crumb.href ? (
        <BreadcrumbPage key={crumb.id} className='whitespace-nowrap'>
          {crumb.label}
        </BreadcrumbPage>
      ) : (
        <BreadcrumbLink key={crumb.id} asChild={false} className='whitespace-nowrap' href={crumb.href}>
          {crumb.label}
        </BreadcrumbLink>
      ),
    )}
  </AranduBreadcrumb>
);

export { Breadcrumb };
